import { render, staticRenderFns } from "./UserExercises.vue?vue&type=template&id=a33c03e0&scoped=true"
import script from "./UserExercises.vue?vue&type=script&lang=js"
export * from "./UserExercises.vue?vue&type=script&lang=js"
import style0 from "./UserExercises.vue?vue&type=style&index=0&id=a33c03e0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33c03e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a33c03e0')) {
      api.createRecord('a33c03e0', component.options)
    } else {
      api.reload('a33c03e0', component.options)
    }
    module.hot.accept("./UserExercises.vue?vue&type=template&id=a33c03e0&scoped=true", function () {
      api.rerender('a33c03e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserExercises.vue"
export default component.exports